import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

export interface IPaginatorConfiguration {
  nzPageSize: number;
  nzDisabled?: boolean;
  nzShowQuickJumper?: boolean;
  nzSimple?: boolean;
  nzSize?: 'small' | 'default';
  nzResponsive?: boolean;
  nzPageSizeOptions?: number[];
  nzItemRender?: TemplateRef<{ $implicit: 'page' | 'prev' | 'next'| 'prev_5'| 'next_5', page: number }> | null;
  nzShowTotal?: TemplateRef<{ $implicit: number, range: [ number, number ] }> | null;
}

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  @Input() index: number;
  @Input() total: number;
  @Input() configuration: IPaginatorConfiguration;
  @Output() change: EventEmitter<number> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    this.setConfigurationDefault();
  }

  setConfigurationDefault(): void {
    const defaultConfig: IPaginatorConfiguration = {
      nzDisabled: false,
      nzPageSize: 30,
      nzResponsive: false,
      nzShowQuickJumper: false,
      nzSize: 'small',
      nzSimple: false
    };
    this.configuration = {
      ...defaultConfig,
      ...this.configuration
    };
  }

  onChange(index): void {
    this.index = index;
    this.change.emit(this.index);
  }
}
